import type { ReactNode } from 'react';
import type { ProgramBlock } from '@/features/events';
import { formatBlockTime } from '@/features/events';
import { OrnamentIcon, type OrnamentIconName } from '@/components/ornaments/OrnamentIcon';
import { cx } from '@/lib/cx';
import styles from './ProgramItem.module.css';

export interface ProgramItemProps {
  block: ProgramBlock;
  /** Ornamento de la izquierda. Por defecto un destello. */
  icon?: OrnamentIconName;
  /** Miniatura circular (Cancun). Sustituye al icono cuando se pasa. */
  media?: ReactNode;
  /** Oculta la hora: los mockups de BA y Cancun no la rotulan en la lista. */
  showTime?: boolean;
  className?: string;
}

/**
 * Una linea del programa: hora, titulo y bajada. Se usa dentro de un `<ol>`.
 * La hora sale SIEMPRE del dato tipado; nadie la teclea en una pagina.
 */
export function ProgramItem({ block, icon = 'star', media, showTime = true, className }: ProgramItemProps) {
  return (
    <li className={cx(styles.item, block.isHighlight && styles.highlight, className)}>
      <span className={styles.marker} aria-hidden="true">
        {media ?? <OrnamentIcon name={icon} size={30} />}
      </span>
      <div className={styles.body}>
        {showTime ? <p className={styles.time}>{formatBlockTime(block)}</p> : null}
        <h4 className={styles.title}>{block.title}</h4>
        {block.description ? <p className={styles.description}>{block.description}</p> : null}
      </div>
    </li>
  );
}
